import {Materiale} from '../models/materiale';
import {Lul} from '../models/lul';
export class MaterialeData {
  title: string;
  materialeList: Array<Materiale>;
  lul: Lul;
}
